export default __webpack_public_path__ + "static/media/mis-peliculas.bcbf2cde.png";